<div
	class="modal fade"
	id="filtersModal"
	tabindex="-1"
	role="dialog"
	aria-labelledby="filtersModalLabel"
	aria-hidden="true"
>
	<div class="modal-dialog modal-dialog-scrollable">
		<div class="modal-content">
			<div class="modal-body">
				<div class="container">
					<div class="mb-3">
						<label for="drivers" class="mt-3">Kierowca</label>
						<ng-select
							id="drivers"
							name="drivers"
							[(ngModel)]="filters.drivers"
							[multiple]="true"
							[closeOnSelect]="false"
						>
							<ng-option *ngFor="let item of allDrivers" [value]="item.id">{{ item.name }}</ng-option>
						</ng-select>
					</div>
					<div class="mb-3">
						<label for="statuses" class="mt-3">Status Kierowcy</label>
						<ng-select
							id="statuses"
							name="statuses"
							[(ngModel)]="filters.statuses"
							[multiple]="true"
							[closeOnSelect]="false"
						>
							<ng-option *ngFor="let item of statuses" [value]="item.id">{{ item.name }}</ng-option>
						</ng-select>
					</div>
					<div class="mb-3">
						<label for="driverKinds" class="mt-3">Rodzaj kierowców</label>
						<ng-select
							id="driverKinds"
							name="driverKinds"
							[(ngModel)]="filters.driverKinds"
							[multiple]="true"
							[closeOnSelect]="false"
						>
							<ng-option *ngFor="let item of driverKinds" [value]="item.id">{{ item.name }}</ng-option>
						</ng-select>
					</div>
					<div class="form-floating mt-3">
						<select
							class="form-select"
							id="showDeleted"
							name="showDeleted"
							[(ngModel)]="filters.showDeleted"
						>
							<!-- <option value="">(brak)</option> -->
							<option [value]="item.id" *ngFor="let item of yesno">
								{{ item.name }}
							</option>
						</select>
						<label for="showDeleted">Pokaż usunięte wydarzenia</label>
					</div>
					<div class="form-floating mt-3">
						<select
							class="form-select"
							id="vaccination"
							name="vaccination"
							[(ngModel)]="filters.vaccinations"
						>
							<option value="">(wszystkie)</option>
							<option [value]="item.id" *ngFor="let item of yesno">
								{{ item.name }}
							</option>
						</select>
						<label for="vaccination">Szczepienie</label>
					</div>
					<div class="form-floating mt-3">
						<select class="form-select" id="trailer" name="trailer" [(ngModel)]="filters.trailer">
							<option value="">(wszystkie)</option>
							<option [value]="item.id" *ngFor="let item of yesno">
								{{ item.name }}
							</option>
						</select>
						<label for="trailer">Przyczepka</label>
					</div>
				</div>
			</div>
			<div class="modal-footer">
				<div class="container">
					<div class="row">
						<div class="col-sm-7 text-start">
							<button type="button" class="btn btn-danger me-1" (click)="filtersClear()">Wyczyść</button>
							<button type="button" class="btn btn-success" (click)="filtersDefault()">Domyślne</button>
						</div>
						<div class="col-sm-5 text-end">
							<button type="button" class="btn btn-primary me-1" (click)="filtersSave()">Pokaż</button>
							<button
								type="button"
								class="btn btn-secondary"
								(click)="filtersClose()"
								data-bs-dismiss="modal"
							>
								Anuluj
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
